export enum Geschlecht {
  M,
  W,
  D,
  A,
  U
}
